import { useEffect, useState } from "react";
import { apiGet, getOrgView, setOrgView } from "../lib/api";
import { Building2 } from "lucide-react";

/**
 * OrgSwitcher — super-admin-only tenant selector. Changing it stores the
 * chosen org slug (sent as X-Org-Slug on every request) and reloads so all
 * dashboards refetch for that tenant.
 */
export default function OrgSwitcher({ user }) {
  const [orgs, setOrgs] = useState([]);
  const [value, setValue] = useState("");

  useEffect(() => {
    apiGet("/admin/organizations")
      .then((d) => {
        const list = d.organizations || [];
        setOrgs(list);
        const current = getOrgView() || (list.find((o) => o.id === user.org_id)?.slug ?? "");
        setValue(current);
      })
      .catch(() => {});
  }, [user.org_id]);

  if (user.role !== "super_admin") return null;

  const onChange = (e) => {
    const slug = e.target.value;
    setValue(slug);
    // default org view can also be represented by its slug; always store it
    setOrgView(slug);
    window.location.reload();
  };

  return (
    <div className="px-[18px] py-3" data-testid="org-switcher" style={{ borderBottom: "1px solid var(--cv-line)" }}>
      <div className="flex items-center gap-1.5 mb-1.5 text-[10.5px] font-bold small-caps" style={{ color: "var(--cv-dark-grey)", letterSpacing: "0.14em" }}>
        <Building2 className="w-3.5 h-3.5" /> Viewing organisation
      </div>
      <select
        value={value}
        onChange={onChange}
        data-testid="org-switcher-select"
        className="w-full text-[13px] px-2.5 py-2 rounded"
        style={{ border: "1px solid var(--cv-line)", background: "#fff", color: "var(--cv-charcoal)" }}
      >
        {orgs.map((o) => (
          <option key={o.id} value={o.slug}>{o.name}</option>
        ))}
      </select>
    </div>
  );
}
